import { render, staticRenderFns } from "./SatisMasrafForm.vue?vue&type=template&id=0cde131f"
import script from "./SatisMasrafForm.vue?vue&type=script&lang=ts"
export * from "./SatisMasrafForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports